/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useMemo, useCallback }  from 'react';
import { isObjectArrayEqual } from 'utils/isObjectArrayEqual';
// material
import { Switch, TextField, Divider, Icon, ToolTip, displayModal } from '@insticator/insticator-ui';
import Space from 'material/space/space';
import CardWrapper from 'material/cardwrapper/cardwrapper';
// content
import Products from './products/products';
import Placement from './placement/placement';
import PreviewModeCode from './previewmodecode/previewmodecode';
import ActionButtons from './actionbuttons/actionbuttons';
// styles
import injectSheet from 'react-jss'
import styles from './productgroup_styles'
import ToggleButton from 'material/togglebutton/togglebutton';
import { useDispatch } from 'react-redux';
import PublishWarning from '../../publishwarning/publishwarning';

const productGroupModeOpt = [
  {label: 'Draft', value: 'draft'},
  {label: 'Live', value: 'current'}
]
/* ========== ~~~~~~~~~~ MODERATION CONFIG V2: GENERAL SECTION ~~~~~~~~~~ ========== */
const ProductGroup = injectSheet(styles)((props) => {
  const dispatch = useDispatch()

  const {
      index,
      group,
      previewModeCode, 
      isDraftChanged,
      onChange, 
      onFieldsChange,
      onRemove,
      siteURL,
      saveDraftText
  } = props;
  const [selectedMode, selectMode] = useState('draft')

  const selectedGroup = useMemo(() => group[selectedMode], [group, selectedMode])

  const handleProductGroupChange = (property, value) => onChange(property, value, selectedMode)

  const handleProductGroupPropertiesChange = (properties) => onFieldsChange(properties, selectedMode)

  const isDraftSavedOnce = !!group.groupId

  const disableSaveDraft = !isDraftChanged

  const [showToggleButtons, setShowToggleButtons] = useState(isDraftSavedOnce)

  const [isSetLiveShown, showSetLive] = useState(false)

  // const disableSetAsCurrent = isDraftChanged || isSetCurrentDisabled
  const disableSetAsCurrent = isDraftSavedOnce ? isObjectArrayEqual(group.draft, group.current) : true

  const onPublish = (action) => {
    if(action === 'saveDraft') {
      // dispatch(displayModal(false))
      showSetLive(true)
    } else {
      // dispatch(displayModal(false))
      selectMode('current')
      setShowToggleButtons(true)
      showSetLive(false)
    }
  }

  const showPublishWarning = (action = 'saveDraft') => dispatch(displayModal(true, <PublishWarning groupIndex={index} action={action} onPublish={() => onPublish(action)} />, false))

  const noProductsEnabled  = useMemo(() => !selectedGroup.showCommenting && !selectedGroup.showArticleSentiment && !selectedGroup.showTrendingNow, [selectedGroup])

  return (
    <CardWrapper klass={`productgroup ${props.classes.productgroup}`}>
      <Space gap={32} direction={'column'}>
        <Space alignItems={'center'} justifyContent={'space-between'}>
          <Space klass={`disabled-${selectedMode === 'current'}`} alignItems={'center'}>
            <Switch on={selectedGroup.groupEnabled} handleClick={()=> handleProductGroupChange('groupEnabled', !selectedGroup.groupEnabled)} variant={'primary'} />
            <TextField 
              type={`text`} 
              name={`productgrouplabel`} 
              value={selectedGroup.label} 
              handleChange={e => { handleProductGroupChange('label', e.target.value)}} 
              label={''}
              placeholder={`Enter group name`} 
              maxLength={128}
              disabled={!selectedGroup.groupEnabled}
              valid={!!selectedGroup.label}
              required
            />
          </Space>
          <Space gap={16} justifyContent={'flex-end'} alignItems={'center'}>
            {showToggleButtons && <ToggleButton items={productGroupModeOpt} selected={selectedMode} onChange={item => selectMode(item.value)} />}
            <ToolTip
              position={'top'}
              trigger={'mouseenter focus'}
              content={'Delete Product Group'}
            >
              <Icon name={'trash'} handleClick={onRemove} />
            </ToolTip>
          </Space>
        </Space>  
        <Space klass={`disabled-${!selectedGroup.groupEnabled || selectedMode === 'current'}`} gap={32}>
          <Products 
            showCommenting={selectedGroup.showCommenting} 
            showTrendingNow={selectedGroup.showTrendingNow} 
            onChange={handleProductGroupChange} 
            onFieldsChange={handleProductGroupPropertiesChange}  
          />
          <Placement groupId={group.groupId} {...selectedGroup} onChange={handleProductGroupChange} />
        </Space>

      {/* {selectedMode === 'draft' &&
        <div className={'globalsave'}>
          <Space alignItems={'flex-start'} klass={`productsetupfooter ${props.classes.productsetupfooter}`} justifyContent={'space-between'}>
            {isDraftSavedOnce && <PreviewModeCode siteURL={siteURL} disabled={!isDraftSavedOnce || isDraftChanged} previewModeCode={previewModeCode} />}
            <ActionButtons 
              hideSetLive={!group.groupId || !isSetLiveShown}
              onSaveDraft={() => showPublishWarning('saveDraft')} 
              onSetCurrent={() => showPublishWarning('setAsCurrent')} 
              saveDraftDisabled={disableSaveDraft} 
              setAsCurrentDisabled={disableSetAsCurrent || isDraftChanged}
              saveDraftText={saveDraftText}
            />
          </Space>
        </div>
      } */}
      <Divider />
         <ActionButtons 
            hideSetLive={!group.groupId || selectedMode === 'current'}
            onSaveDraft={() => showPublishWarning('saveDraft')} 
            onSetCurrent={() => showPublishWarning('setAsCurrent')} 
            saveDraftDisabled={disableSaveDraft} 
            setAsCurrentDisabled={noProductsEnabled || disableSetAsCurrent || isDraftChanged}
            saveDraftText={saveDraftText}
          />
      </Space>

  </CardWrapper>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ProductGroup;